module.exports = vendor_VENDOR;